import { Box, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
	columns: number;
	gap?: number;
	alignContent?: "start" | "space-around";
}>;

export const FlatRowDatePanelGrid: FC<Props> = ({
	columns,
	gap,
	alignContent = "space-around",
	children,
}) => {
	const { spacingTokens, datePanel } = useTheme();

	return (
		<Box
			display="grid"
			gridTemplateColumns={`repeat(${columns}, 1fr)`}
			rowGap={gap}
			columnGap={gap ?? datePanel.columnGap}
			alignContent={alignContent}
			height={datePanel.gridHeight}
			px={spacingTokens.xl}
		>
			{children}
		</Box>
	);
};
